var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"fixed":"","app":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleSidebar.apply(null, arguments)}}}),_c('v-spacer'),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }